import * as React from "react"

import {
  FixedCTAFooter,
  GlobalCSS,
  Theme,
  media
} from "@life-without-barriers/react-components"
import Form, {
  DataFormatters,
  FieldsProps,
  FormFields
} from "@life-without-barriers/shared-contact-form"
import { Location, SiteMetaData } from "@life-without-barriers/gatsby-common"
import Footer from "./Footer"
import styled, { ThemeProvider } from "styled-components"

import Header from "./Header"
const { Name, Postcode, ContactMethodToggleField, MessageTextArea } = FormFields

export interface Props {
  children: React.ReactNode
  location: Location
  siteMetadata: SiteMetaData
}

const StyledContent = styled.div`
  margin-top: 77px;
`
const StyledFooter = styled.div`
  padding-bottom: 80px;

  ${media.notSmall`
    padding-bottom: 0px;
  `}
`

const { carerGuideThemeFull } = Theme

const throwIfNoSessionStorage = () => {
  if (window === undefined || !window.sessionStorage) {
    throw Error("Session storage unavailable")
  }
}

const getItem = (key: string, options?: { parse: boolean }): unknown => {
  throwIfNoSessionStorage()
  const item = window.sessionStorage.getItem(key)
  return !item ? null : options?.parse ? JSON.parse(item) : item
}

const addSelfAssessment = (formData: Record<string, unknown>) => {
  const selfAssessment = getItem("self-assessment-answers", { parse: true })
  return selfAssessment
    ? { ...formData, selfAssessment, selfAssessmentDisplayed: true }
    : { ...formData, selfAssessmentDisplayed: false }
}

const dataFormatter = (
  formData: Record<string, unknown>
): Record<string, unknown> => {
  let result = DataFormatters.addFormUrl(formData, "formUrl")
  result = DataFormatters.nestContactDetailsFormatter(result)
  result = addSelfAssessment(result)
  return result
}

const CarerGuideForm = () => (
  <Form
    formId="carer-guide-form"
    formKind="foster-care"
    url="/api/www/contact/contact-lwb"
    successTitle={"Thanks for your enquiry"}
    successMessage={"Our team will be in touch within the next business day."}
    fieldFactory={(fieldsProps: FieldsProps) => [
      <Name key="Name" {...fieldsProps} />,
      <Postcode key="Postcode" {...fieldsProps} />,
      <ContactMethodToggleField
        key="ContactMethodToggleField"
        initialContactMethod="phone"
        {...fieldsProps}
      />,
      <MessageTextArea key="MessageTextArea" {...fieldsProps} />
    ]}
    initialValues={{ contactMethod: "phone" }}
    formDataFormatter={dataFormatter}
  />
)

const Layout = (props: Props) => {
  return (
    <ThemeProvider theme={carerGuideThemeFull}>
      <div className="overflow-hidden">
        <GlobalCSS />
        <Header location={props.location} siteMetadata={props.siteMetadata} />
        <StyledContent role="main">{props.children}</StyledContent>
        <StyledFooter>
          <Footer />
          <FixedCTAFooter
            phoneNumber="1300592227"
            dialogContent={<CarerGuideForm />}
          />
        </StyledFooter>
      </div>
    </ThemeProvider>
  )
}

export default Layout
